// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticketDiv{
    gap: 5rem;
    padding: 0rem 5rem;
    z-index: 3 !important;
}
.ticketDiv_left>h2{
    text-decoration: underline;
    text-decoration-thickness: 5px;
}
.ticketDiv_left{
    z-index: 3;
    display: flex;
    flex-direction: column;
    width: 50%;
    gap: 1rem;
    margin-bottom: 10%;
}
.ticketDiv_left>h2{
    text-underline-offset: 0.5rem;
}
.ticketBtn{
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 0.1rem;
    display: flex;
    gap: 0.4rem;
    justify-content: center;
    align-items: center;
    width: 40%;
}
.ticketDiv_right{
    z-index: 3;
    width: 50%;
    margin-top: 12%;
}
.ticketDiv_right>img{
    width: 100%;
    height: 100%;
}
.ticketDot{
    position: absolute;
    left: -11rem;
    transform: scaleY(-1);
    z-index: -1;
    display: flex;
    justify-self: start;
}
@media only screen and (max-width: 1200px){
    .ticketDiv{
        gap: 3rem;
        padding: 0rem 3rem;
        z-index: 3 !important;
    }
    .ticketBtn{
        width: 60%;
    }
    .ticketDiv_right{
        margin-top: 22%;
    }
    .ticketDiv_left{
        width: 50%;
        margin-bottom: 0%;
    }
}

@media only screen and (max-width: 800px) {
    .ticketDiv{
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 0rem 3rem;
    }
    .ticketDiv_right{
        margin-top: 0%;
        width: 50%;
        margin-right: -50%;
    }
    .ticketDiv_left{
        width: 100%;
        margin-bottom: 0%;
    }
    .ticketDot{
        left: -13rem;
    }
    .ticketBtn{
        width: 30%;
    }
}


@media only screen and (max-width: 550px) {
    .ticketDiv{
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 0rem 2rem;
        margin-top: 3rem;
    }
    .ticketDiv_left{
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 1rem;
    }
    .ticketDot{
        display: none;
    }
    .ticketBtn{
        width: 40%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/TicketComp/TicketComp.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,6BAA6B;IAC7B,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,UAAU;IACV,UAAU;IACV,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;AACA;IACI;QACI,SAAS;QACT,kBAAkB;QAClB,qBAAqB;IACzB;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;;;AAGA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,SAAS;IACb;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".ticketDiv{\n    gap: 5rem;\n    padding: 0rem 5rem;\n    z-index: 3 !important;\n}\n.ticketDiv_left>h2{\n    text-decoration: underline;\n    text-decoration-thickness: 5px;\n}\n.ticketDiv_left{\n    z-index: 3;\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    gap: 1rem;\n    margin-bottom: 10%;\n}\n.ticketDiv_left>h2{\n    text-underline-offset: 0.5rem;\n}\n.ticketBtn{\n    text-decoration: underline;\n    text-decoration-thickness: 2px;\n    text-underline-offset: 0.1rem;\n    display: flex;\n    gap: 0.4rem;\n    justify-content: center;\n    align-items: center;\n    width: 40%;\n}\n.ticketDiv_right{\n    z-index: 3;\n    width: 50%;\n    margin-top: 12%;\n}\n.ticketDiv_right>img{\n    width: 100%;\n    height: 100%;\n}\n.ticketDot{\n    position: absolute;\n    left: -11rem;\n    transform: scaleY(-1);\n    z-index: -1;\n    display: flex;\n    justify-self: start;\n}\n@media only screen and (max-width: 1200px){\n    .ticketDiv{\n        gap: 3rem;\n        padding: 0rem 3rem;\n        z-index: 3 !important;\n    }\n    .ticketBtn{\n        width: 60%;\n    }\n    .ticketDiv_right{\n        margin-top: 22%;\n    }\n    .ticketDiv_left{\n        width: 50%;\n        margin-bottom: 0%;\n    }\n}\n\n@media only screen and (max-width: 800px) {\n    .ticketDiv{\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        padding: 0rem 3rem;\n    }\n    .ticketDiv_right{\n        margin-top: 0%;\n        width: 50%;\n        margin-right: -50%;\n    }\n    .ticketDiv_left{\n        width: 100%;\n        margin-bottom: 0%;\n    }\n    .ticketDot{\n        left: -13rem;\n    }\n    .ticketBtn{\n        width: 30%;\n    }\n}\n\n\n@media only screen and (max-width: 550px) {\n    .ticketDiv{\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        padding: 0rem 2rem;\n        margin-top: 3rem;\n    }\n    .ticketDiv_left{\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        gap: 1rem;\n    }\n    .ticketDot{\n        display: none;\n    }\n    .ticketBtn{\n        width: 40%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
